package com.downdogapp.client.singleton

import com.downdogapp.*
import com.downdogapp.client.Strings
import com.downdogapp.client.api.*
import com.downdogapp.client.controllers.HistoryItemViewController
import com.downdogapp.client.controllers.start.HistoryPage
import com.downdogapp.client.controllers.start.StartViewController
import com.downdogapp.client.controllers.start.StatsPage

object HistoryUtil {

  private var response = HistoryResponse(mutableListOf())

  val HistoryItem.favorite get() = properties?.favorite ?: false
  val HistoryItem.name get() = properties?.name

  val items get() = response.items
  val favorites get() = items.filter { it.favorite }.distinctBy { it.sequenceId }

  fun isFavorite(sequenceId: String) =
    getProperties(sequenceId)?.favorite == true

  fun fetchHistory() {
    Network.post(HistoryRequest()) { json ->
      if (json != null) {
        response = HistoryResponse.fromJson(json)
        HistoryPage.view.refreshView()
        StatsPage.view.refreshView()

        if (UserPrefs[Key.LinkedPracticeId] != null) {
          val linkedHistoryItem = response.items.firstOrNull {
            it.practiceId == UserPrefs[Key.LinkedPracticeId]!!
          }
          if (linkedHistoryItem != null) {
            App.unwindToViewController(StartViewController::class)
            StartViewController.goToPage(HistoryPage)
            App.runAfter(seconds(0.5)) {
              App.pushViewController(
                HistoryItemViewController(linkedHistoryItem)
              )
            }
          } else {
            App.alert(message = Strings.UNABLE_TO_OPEN_LINKED_PRACTICE)
          }
          UserPrefs.remove(Key.LinkedPracticeId)
        }
      }
    }
  }

  fun deletePractice(practiceId: String) {
    Logger.logEvent("delete_history_item", mapOf("practiceId" to practiceId))
    val practice = response.items.find { it.practiceId == practiceId }!!
    response.items.remove(practice)
    Network.post(DeleteHistoryItemRequest(practiceId = practiceId)) {
      fetchHistory()
    }
  }

  fun renameSequence(sequenceId: String, name: String) {
    getProperties(sequenceId)?.name = name
    Network.post(RenameHistorySequenceRequest(sequenceId, name)) {
      fetchHistory()
    }
  }

  fun updateSequenceFavorite(sequenceId: String, favorite: Boolean, callback: (success: Boolean) -> Unit = {}) {
    getProperties(sequenceId)?.favorite = favorite
    Network.post(UpdateHistorySequenceFavoritedRequest(sequenceId, favorite)) { json ->
      fetchHistory()
      callback(json != null)
    }
  }

  private fun getProperties(sequenceId: String) = response.properties[sequenceId]
  private val HistoryItem.properties get() = getProperties(sequenceId)
}
